// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l9-0";
export var discountCodeInput = "_l9-1";